import colors from 'globals/colors'
import measures from 'globals/measures'
import styled from 'styled-components'

interface SearchBarWrapperProps {
  marginBottom?: boolean,
  backgroundColor?: string,
  height?: string
}

export const SearchBarWrapper = styled.div<SearchBarWrapperProps>`
  display: flex;
  border-radius: 4px;
  ${(props) => props.marginBottom && 'margin-bottom: 23px;'}
  ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`}

  & > span.ant-input-affix-wrapper {
    ${(props) => props.height ? `line-height: ${props.height};` : 'line-height: 48px;'}
    ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`}
    border: none;
    border-radius: 4px;
    padding: 0 16px;
    flex: 1;

    & > span.ant-input-prefix {
      margin-right: 16px;
    }

    & > input {
      ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`}
    }
  }
  @media(max-width: 800px) {
    margin-right: 19px;
  }
  @media(max-width: ${measures.mobileThreshold}px) {
   margin-right: 0px;
  }
`

export const FiltersWrapper = styled.div`
  height: 48px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;
  margin-left: 24px;
  padding: 12px 13px;
  display: flex;
  
  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

interface FilterButtonProps {
  active: boolean
}

export const FilterButton = styled.span<FilterButtonProps>`
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  padding: 0 13px;
  margin-left: 5px;
  cursor: pointer;
  
  &:first-child {
    margin-left: 0;
  }
  
  ${(props) => props.active && `
    color: white;
    background: ${colors.darkGrey};
  `};
`

export const FiltersMobileWrapper = styled.div`
  position: relative;
`

interface FiltersMobileButtonProps {
  active: boolean
}

export const FiltersMobileButton = styled.span<FiltersMobileButtonProps>`
  width: 48px;
  height: 48px;
  font-size: 24px;
  background: white;
  border-radius: 4px;
  margin-left: 9px;
  display: none;
  align-items: center;
  justify-content: center;
  
  @media(max-width: ${measures.mobileThreshold}px) {
    display: flex;
  }
  
  ${(props) => props.active && `
    color: white;
    background: ${colors.waterBlue};
  `};
`

interface FiltersMobileListProps {
  show: boolean
}

export const FiltersMobileList = styled.div<FiltersMobileListProps>`
  min-width: 148px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 3px 18px;
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  opacity: 0;
  z-index: -1;  
  transition: opacity 300ms, z-index 0s 300ms;
  
  ${(props) => props.show && `
    opacity: 1;
    z-index: 1001;
    transition: opacity 300ms, z-index 0s 0s;
  `};
`

interface FilterMobileLinkProps {
  active: boolean
}

export const FilterMobileLink = styled.span<FilterMobileLinkProps>`
  line-height: 40px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  
  ${(props) => props.active && `
    color: ${colors.waterBlue};
  `};
`
